// extracted by mini-css-extract-plugin
export default {"container":"Products_container__avLY9","products":"Products_products__rmm66","menu":"Products_menu__m0BYC","list":"Products_list__2R0FY","product":"Products_product__8Ri4f"};